import { render, staticRenderFns } from "./athleteProfile.vue?vue&type=template&id=2f8a0eaa&scoped=true&"
import script from "./athleteProfile.vue?vue&type=script&lang=js&"
export * from "./athleteProfile.vue?vue&type=script&lang=js&"
import style0 from "./athleteProfile.vue?vue&type=style&index=0&id=2f8a0eaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8a0eaa",
  null
  
)

export default component.exports